/**
 * Agent / Shared Types
 * Re-exports from service-specific type files and shared types for agent/websocket.
 */

export * from './work-items';
export * from './events';
export * from './user-profiles';
export * from './runtime';
export * from './service-interfaces';

import { z } from 'zod';
import type { WorkItem } from './work-items';

/**
 * Project Context - Overall context for a project
 */
export const ProjectContextSchema = z.object({
  projectId: z.string(),
  context: z.record(z.unknown()).default({}),
  updatedAt: z.string(),
});
export type ProjectContext = z.infer<typeof ProjectContextSchema>;

/**
 * WebSocket Message Types (worker → IDE clients)
 */
export const WebSocketMessageTypeSchema = z.enum([
  'plan-update',
  'work-item-update',
  'work-item-added',
  'work-item-removed',
  'project-processing-start',
  'project-processing-update',
  'project-processing-complete',
  'project-processing-error',
  'file-tool-request',
  'file-tool-response',
  'file-generated',
]);
export type WebSocketMessageType = z.infer<typeof WebSocketMessageTypeSchema>;

export const WebSocketMessageSchema = z.object({
  type: WebSocketMessageTypeSchema,
  contextId: z.string().optional(),
  data: z.any().optional(),
  error: z.string().optional(),
});
export type WebSocketMessage = z.infer<typeof WebSocketMessageSchema>;

export interface WorkItemWebSocketData {
  workItem?: WorkItem;
  workItemId?: string;
}
